import { faBell } from '@fortawesome/free-regular-svg-icons'
import React, { useState } from 'react'

import IconButton from '@/components/IconButton'
import SubjectActivityFeed from '@/components/SubjectActivityFeed'
import type { Application } from '@/types/Activity'

interface Props {
  application: Application
}

const Notifications = ({ application }: Props) => {
  const [notificationsSidebarOpen, setNotificationsSidebarOpen] = useState(false)

  return (
    <>
      {notificationsSidebarOpen && (
        <SubjectActivityFeed
          applicationName={application.context?.firstName}
          applicationId={application.applicationId}
          customerId={application.customerId}
          onClose={() => setNotificationsSidebarOpen(false)}
          subjectId={application.subjectId}
        />
      )}
      <IconButton
        tooltipMessage="View notifications"
        icon={faBell}
        onClick={() => setNotificationsSidebarOpen(true)}
      />
    </>
  )
}

export default Notifications
